import $ from 'jquery';

class Marquee {
    constructor(speed) {
        this.speed = speed;
        this.$marquee = $('.marquee');

        this.events();
    }

    events() {
        $('body').on('font-size-change', () => {
            this.$marquee.each((id, el) => {
                let $el = $(el).find('span'),
                    textWidth = $el.outerWidth(),
                    t = Math.round(textWidth / this.speed);

                $el.css('animation-duration', t + 's');
            });
        });
    }
}

export default Marquee;



// WEBPACK FOOTER //
// ./sources/js/components/marquee.js